;(function ($) {
  "use strict"

  $(document).ready(function () {
    $(".accordion").accordion({
      active: false,
      collapsible: true,
      heightStyle: "content",
      animate: 200,
    })
  })
})(jQuery)
